export default __webpack_public_path__ + "static/product_002-6e424e40975ce01116ad7acb3b70a163.jpg";